import React from 'react'

const BuySellLoggedWelcome = () => {
    return (
        <div>BuySellLoggedWelcome</div>
    )
}

export default BuySellLoggedWelcome